import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IconArrowUpRight } from "@tabler/icons-react";
import { fadeUp } from "./animations";

export default function TechnologyCTA() {
  return (
    <section
      className="
        bg-[#f6f6f6]
        px-[14px]
        py-10
        sm:px-5
      "
    >
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
        }}
        className="
          relative
          mx-auto
          max-w-[1320px]
          overflow-hidden
          rounded-[24px]
          bg-[#101010]
          px-6
          py-20
          text-white
          sm:px-10
          lg:px-16
          lg:py-24
        "
      >
        <div
          className="
            pointer-events-none
            absolute
            -right-32
            -top-32
            h-[450px]
            w-[450px]
            rounded-full
            bg-[#55aef3]/15
            blur-[120px]
          "
        />

        <div
          className="
            relative
            z-10
            grid
            gap-10
            lg:grid-cols-[1fr_auto]
            lg:items-end
          "
        >
          <div>
            <p
              className="
                text-[10px]
                font-bold
                uppercase
                tracking-[0.22em]
                text-[#55aef3]
              "
            >
              Have an idea?
            </p>

            <h2
              className="
                merriweather
                mt-5
                max-w-[760px]
                text-3xl
                font-black
                tracking-[-0.04em]
                sm:text-4xl
                lg:text-[58px]
                lg:leading-[1.05]
              "
            >
              Let's turn it
              <span className="block text-[#55aef3]">
                into something real.
              </span>
            </h2>

            <p
              className="
                mt-6
                max-w-2xl
                text-[15px]
                leading-8
                text-white/50
              "
            >
              Whether you need software, a mobile application, a campaign or
              an entirely new digital experience, WE3X Technologies is ready
              to build it with you.
            </p>
          </div>

          <Link
            to="/contact"
            className="
              group
              inline-flex
              w-fit
              items-center
              gap-2
              rounded-[9px]
              bg-white
              px-7
              py-4
              text-sm
              font-bold
              text-black
              transition-all
              hover:-translate-y-1
              hover:bg-[#55aef3]
              hover:text-white
            "
          >
            Start Your Project
            <IconArrowUpRight
              size={17}
              className="
                transition-transform
                group-hover:translate-x-1
                group-hover:-translate-y-1
              "
            />
          </Link>
        </div>

        <div
          className="
            relative
            z-10
            mt-14
            border-t
            border-white/10
            pt-6
            text-xs
            font-semibold
            tracking-wide
            text-white/30
          "
        >
          Plan it. Design it. Build it. Grow it.
        </div>
      </motion.div>
    </section>
  );
}
